export default __webpack_public_path__ + "static/media/promo-spectrespecs_02.419f3647.jpg";